import { Currency } from 'types';

import { createCrudApi } from './crud.api';

export const assetCurrencyApi = createCrudApi<Currency>('/currencies/asset');
